"use client";

import { SystemErrorScreen } from "@/components/errors/system-error-screen";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="pt-BR">
      <body>
        <SystemErrorScreen onRetry={reset} />
      </body>
    </html>
  );
}
